import CheckoutCancel from '../pages/Cancel';
import CheckoutSuccess from '../pages/Success';

/**
 * gets checkout page component
 * @param {Object} options
 * @param {string} options.path
 * @return {ReactNode}
 */
export const getCheckoutPageComponent = ({ path }) => {
  switch (path) {
    case 'cancel':
      return <CheckoutCancel />;
    case 'success':
      return <CheckoutSuccess />;
    default:
      return null;
  }
};
